import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";
import TabletLayout from "./TabletLayout";

// import CustomSizeLayout from './CustomSizeLayout';

const LayoutForProps = function (windowSize, isMobile, isTablet, isIOS, isOpen, isFormFocused, isHovered, position, collapsedStyle, config) {
  // if (customSize) {
  //   return CustomSizeLayout(windowSize, isMobile, isTablet, isIOS,isOpen,isFormFocused, isHovered,position,collapsedStyle, customSize);
  //
  // }
  if (!windowSize) {
    windowSize = { width: 0, height: 0 };
  }

  if (isMobile) {
    if (isTablet) {
      return TabletLayout(windowSize, isMobile, isTablet, isIOS, isOpen, isFormFocused, isHovered, position, collapsedStyle, config);
    } else {
      return MobileLayout(windowSize, isMobile, isTablet, isIOS, isOpen, isFormFocused, isHovered, position, collapsedStyle, config);
    }
  } else {
    return DesktopLayout(windowSize, isMobile, isTablet, isIOS, isOpen, isFormFocused, isHovered, position, collapsedStyle, config);
  }
};

export default LayoutForProps;
